const trimEnv = (value: string | undefined): string => value?.trim() ?? "";

const POSTHOG_DIRECT_API_HOST = "https://us.i.posthog.com";
const POSTHOG_FIRST_PARTY_PROXY_PATH = "/ph";

const posthogHostFromEnv = trimEnv(process.env.NEXT_PUBLIC_POSTHOG_HOST);

export const marketingAnalyticsEnv = {
  gtmId: trimEnv(process.env.NEXT_PUBLIC_GTM_ID),
  posthogKey: trimEnv(process.env.NEXT_PUBLIC_POSTHOG_KEY),
  posthogHost: posthogHostFromEnv || POSTHOG_FIRST_PARTY_PROXY_PATH,
  openaiAdsPixelId: trimEnv(process.env.NEXT_PUBLIC_OPENAI_ADS_PIXEL_ID),
};

export const marketingAnalyticsUsesPosthogProxy = (): boolean =>
  marketingAnalyticsEnv.posthogHost !== POSTHOG_DIRECT_API_HOST;

export const isMarketingAnalyticsConfigured = (): boolean =>
  Boolean(
    marketingAnalyticsEnv.gtmId ||
    marketingAnalyticsEnv.posthogKey ||
    marketingAnalyticsEnv.openaiAdsPixelId,
  );
